import { useRouter } from 'next/router';
import { useCallback } from 'react';

const useUpdateRouter = () => {
  const router = useRouter();
  const updateRouter = useCallback(
    (replaceWith: any) => {
      router.replace(replaceWith, undefined, { scroll: false });
    },
    [router],
  );

  return { updateRouter };
};

export default useUpdateRouter;
